<div
  class="play-button-tooltip-container"
  (mouseenter)="showTooltip()"
  (mouseleave)="hideTooltip()"
  (focusin)="showTooltip()"
  (focusout)="hideTooltip()">
  <button
    #playButton
    type="button"
    class="btn viewer-controller-icon-btn btn-play"
    aria-label="Play/Pause"
    (click)="togglePlay.emit()">
    <img [hidden]="!playing" src="/assets/svg/subsection/pause.svg" alt="Pause" width="12" height="14" />
    <img [hidden]="playing" src="/assets/svg/subsection/play.svg" alt="Play" width="12" height="14" />
  </button>
</div>
